import React from 'react';
import Footer from './Footer';

class Header extends React.Component {
    render() {
        return (
            <header id="header">
                <div className="inner">
                    <h1>
                        <strong>MyTruck.net</strong> is a premium domain<br />
                        name that is now for sale.
                    </h1>
                </div>
                <Footer />
            </header>
        );
    }
}

export default Header;



// WEBPACK FOOTER //
// ./src/components/Header.js